import { settings } from './settings';

const queryString = require('query-string');

const parsed = queryString.parse(window.location.search);

var state = {};
state = new Object();
let hasData = false;

if (typeof parsed === 'object' && 'data' in parsed && typeof parsed.data === 'string' && parsed.data) {
	try {
		// data = JSON.parse(parsed.data);

		var lz = require('lz-string');
		let data = lz.decompressFromEncodedURIComponent(parsed.data);
		data = JSON.parse(data);
		data = data.state;

		settings.map((parent) => {
			parent.fields.map((field) => {
				let key = parent.id + '_' + field.id;
				if (key in data) {
					state[key] = data[key];
				} else {
					state[key] = field.value;
				}
			});
		});

		hasData = true;
	} catch (e) {
		hasData = false;
	}
}

if (!hasData) {
	settings.map((parent) => {
		parent.fields.map((field) => {
			state[parent.id + '_' + field.id] = field.value;
		});
	});
}

export const st = state;
